module.exports = __webpack_public_path__ + "static/media/tracking-truck.66636857.svg";